import clsx from 'clsx';
import React from 'react';

import CustomImage from '@/components/CustomImage';

interface IEmptyStateProps {
  imageSrc?: string;
  imageAlt?: string;
  title: string;
  description?: string;
  actions?: React.ReactNode;
  className?: string;
  dataTestId?: string;
  width?: number;
  height?: number;
  titleClassName?: string;
}

const EmptyState: React.FC<IEmptyStateProps> = ({
  imageSrc = '/not-found.svg',
  imageAlt = 'Empty state',
  title,
  description,
  actions,
  className,
  dataTestId = 'empty-state',
  width = 171,
  height = 171,
  titleClassName,
}) => {
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center gap-6 w-full h-[75vh] px-4',
        className
      )}
      data-testid={dataTestId}
    >
      <CustomImage
        src={imageSrc}
        alt={imageAlt}
        width={width}
        height={height}
        className="object-contain"
      />

      <div className="flex flex-col items-center gap-2 text-center max-w-185">
        <h3
          className={clsx(
            'text-2xl font-semibold text-neutral-primary',
            titleClassName
          )}
        >
          {title}
        </h3>
        <p className="text-base font-normal text-neutral-secondary leading-6">
          {description}
        </p>
      </div>

      {actions && (
        <div
          className="flex items-center gap-3"
          data-testid={`${dataTestId}-actions`}
        >
          {actions}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
